import fetch from "auth/FetchInterceptor";

const NotificationService = {};
const BasePath = "/notification";

NotificationService.list = function (data) {
  const payload = data || {};
  return {
    queryKey: ['get_all_notifications', payload],
    queryFn: () => fetch({
      url: BasePath + "s",
      method: "Post",
      data: payload
    })
  }
}

NotificationService.getUnreadCount = function () {
  return {
    queryKey: ['get_notification_unread_count'],
    queryFn: () => fetch({
      url: BasePath + "/unread-count",
      method: "Get"
    })
  }
}

NotificationService.markRead = function (id) {
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: {
      action: "markRead",
      id
    }
  })
}

NotificationService.markAllRead = function () {
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: {
      action: "markAllRead"
    }
  })
}

NotificationService.getDeliveryStatus = function (notificationId) {
  return fetch({
    url: BasePath + "/do_action",
    method: "Post",
    data: {
      action: "getDeliveryStatus",
      notificationId
    }
  })
}

NotificationService.createManual = function (data) {
  return fetch({
    url: BasePath + "/",
    method: "Post",
    data
  })
}

export default NotificationService;
